<template>
  <div>
    <a-table
      :columns="columns"
      :dataSource="data"
      :scroll="{ y: 'calc(100vh - 380px)' }"
      :locale="{
        emptyText: $tc('lang.No_data'),
      }"
      :pagination="{
        total: total,
        current: page,
        pageSize: size,
        onChange: onChangePage,
      }"
    >
      <span slot="action" slot-scope="record">
        <a-button
          style="background: #00BAAD;border: 1px solid; #00BAAD；margin: 0 5px "
          type="primary"
          @click="action(record)"
          size="small"
          >上传</a-button
        >
        <a-button
          style="background: #2A82E4;border: 1px solid #2A82E4;margin: 0 5px "
          type="primary"
          @click="action(record)"
          size="small"
          >查看</a-button
        >
      </span>
    </a-table>
  </div>
</template>
<script>
// const columns = ;

// 购买记录
export default {
  data() {
    return {
      Chinese: '',
      data: [],
      page: 1,
      size: 10,
      total: 10,
      loading: true,
      user: {},
    };
  },
  created() {
    this.queryMealPay();
    //判断当前语言环境
    if (this.$i18n.locale === 'zh-CN') {
      this.Chinese = true;
    } else if (this.$i18n.locale === 'en-US') {
      this.Chinese = false;
    }
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
    columns() {
      return [
        {
          title: this.$tc('lang.UserCenter.Item_Nr'),
          align: 'center',
          width: '8%',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: this.$tc('lang.UserCenter.Package_Order_Nr'),
          dataIndex: 'orderId',
          key: 'orderId',
          width: '15%',
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Package'),
          dataIndex: this.Chinese == true ? 'setmealName' : 'setmealEnname',
          key: this.Chinese == true ? 'setmealName' : 'setmealEnname',
          width: '15%',
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Purchase_Date'),
          key: 'setmealPaydate',
          dataIndex: 'setmealPaydate',
          width: '15%',
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Quantity'),
          key: 'setmealPaycount',
          dataIndex: 'setmealPaycount',
          width: '8%',
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Sum'),
          key: 'setmealOnlinepay',
          dataIndex: 'setmealOnlinepay',
          width: '8%',
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Total_MD'),
          key: 'setmealCount',
          dataIndex: 'setmealCount',
          width: '8%',
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Status'),
          key: 'setmealState',
          dataIndex: 'setmealState',
          width: '10%',
          align: 'center',
          customRender: (text, record) => {
            if (this.Chinese == true) {
              if (record.setmealState == 1) {
                return '线上付款';
              } else if (record.setmealState == 2) {
                return '线下付款';
              } else if (record.setmealState == 3) {
                return '待付款';
              }
            } else {
              if (record.setmealState == 1) {
                return 'Paid';
              } else if (record.setmealState == 2) {
                return 'Paid';
              } else if (record.setmealState == 3) {
                return 'Unpaid';
              }
            }
          },
        },
        // {
        //   title: this.$tc('lang.UserCenter.Voucher'),
        //   key: 'setmealPayment',
        //   scopedSlots: { customRender: 'setmealPayment' },
        //   width: '15%',
        //   align: 'center',
        //   // fixed: 'right',
        // },
      ];
    },
  },
  watch: {
    language() {
      if (this.language === 'zh-CN') {
        this.Chinese = true;
      } else if (this.language === 'en-US') {
        this.Chinese = false;
      }
    },
  },
  methods: {
    action(value) {
      console.log(value);
    },
    // 切换页码
    onChangePage(page) {
      this.page = page;
      this.queryMealPay();
    },
    // 表格请求
    queryMealPay() {
      // 获取用户session信息
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
      this.$http
        .post('/hzwmj/person-setmealpay/getMealPay', {
          // params: {
          personId: this.user.id,
          page: this.page,
          size: this.size,
          // },
        })
        .then(data => {
          if (data.code === 200) {
            const buyData = data.data;
            this.data = buyData.records;
            this.total = buyData.total;
          } else if (data.code === 900) {
            this.$message.error(data.msg);
          } else {
            this.$message.error('系统异常');
          }
        })
        .catch(() => {
          this.data = [];
          this.total = 0;
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less"></style>
